import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import { REGIONS, OS_TYPES, INITIAL_INSTANCE_TYPES, API_CONFIG } from './constants';
import { cyberpunkColors } from './theme/cyberpunkTheme';

const Form = (props) => {
  const [instances, setInstances] = useState(INITIAL_INSTANCE_TYPES);

  async function onChangeHandle(value) {
    const region = value;
    try {
      const response = await fetch(`${API_CONFIG.INSTANCES_URL}/instances/${region}/`);
      const apiData = await response.json();
      if (region) {
        setInstances(apiData);
      } else {
        setInstances(INITIAL_INSTANCE_TYPES);
      }
    } catch (err) {
      setInstances(INITIAL_INSTANCE_TYPES);
    }
  }

  const textFieldStyles = {
    '& .MuiFilledInput-root': {
      backgroundColor: 'rgba(0, 255, 255, 0.05)',
      border: '1px solid rgba(0, 255, 255, 0.3)',
      borderRadius: 1,
      '&:hover': {
        backgroundColor: 'rgba(0, 255, 255, 0.08)',
        borderColor: cyberpunkColors.neonCyan,
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(255, 0, 255, 0.05)',
        borderColor: cyberpunkColors.neonMagenta,
        boxShadow: '0 0 10px rgba(255, 0, 255, 0.3)',
      },
      '&::before, &::after': {
        display: 'none',
      },
    },
    '& .MuiInputLabel-root': {
      color: cyberpunkColors.textSecondary,
      fontFamily: '"Rajdhani", sans-serif',
      fontWeight: 600,
      '&.Mui-focused': {
        color: cyberpunkColors.neonMagenta,
      },
    },
    '& .MuiInputBase-input': {
      color: cyberpunkColors.textPrimary,
      fontFamily: '"Rajdhani", sans-serif',
    },
  };

  return (
    <form onSubmit={props.getSpot}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Autocomplete
          onChange={(event, value) => onChangeHandle(value)}
          id="region"
          freeSolo
          options={REGIONS.map((option) => option.region)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Region"
              placeholder="Select AWS Region"
              name="region"
              variant="filled"
              sx={textFieldStyles}
            />
          )}
          sx={{
            '& .MuiAutocomplete-popupIndicator': {
              color: cyberpunkColors.neonCyan,
            },
          }}
        />

        <Autocomplete
          id="ec2_type"
          freeSolo
          options={instances.map((option) => option.ec2_type)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="EC2 Type"
              placeholder="Select Instance Type"
              name="ec2_type"
              variant="filled"
              sx={textFieldStyles}
            />
          )}
          sx={{
            '& .MuiAutocomplete-popupIndicator': {
              color: cyberpunkColors.neonCyan,
            },
          }}
        />

        <Autocomplete
          id="os_type"
          freeSolo={false}
          popupIcon=""
          options={OS_TYPES.map((option) => option.os)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Operating System"
              placeholder="Select OS"
              name="os_type"
              variant="filled"
              sx={textFieldStyles}
            />
          )}
        />

        <Button
          type="submit"
          variant="contained"
          onClick={props.onSubmit}
          sx={{
            mt: 2,
            py: 1.5,
            fontFamily: '"Orbitron", sans-serif',
            fontWeight: 600,
            letterSpacing: '0.1em',
            background: `linear-gradient(135deg, ${cyberpunkColors.neonCyan} 0%, ${cyberpunkColors.neonMagenta} 100%)`,
            color: cyberpunkColors.darkBg,
            border: 'none',
            '&:hover': {
              background: `linear-gradient(135deg, ${cyberpunkColors.neonMagenta} 0%, ${cyberpunkColors.neonCyan} 100%)`,
              boxShadow: `0 0 20px ${cyberpunkColors.neonCyan}, 0 0 40px ${cyberpunkColors.neonMagenta}`,
            },
          }}
        >
          Analyze Pricing
        </Button>
      </Box>
    </form>
  );
};

export default Form;
